import { API_PROTECTED_PATH, API_URL_PRD } from "../config/config";
import { getStorageAuthToken } from "../../utils/token";
import store from "../../store";
import ApiClient from "../requests";

export async function getMolecules(payload: { search: string, lg: string }) {
  const _authToken = store.authToken;

  if (_authToken) {
    const urlParams = `lang=${payload.lg}&date_version=&searchString=${payload !== undefined ? (payload.search ? payload.search : "") : ""
      }`;
    const Url = `${API_URL_PRD}${API_PROTECTED_PATH}molecule/getMolecules?${urlParams}`;

    const res = await ApiClient.get(Url, _authToken);
    if (Array.isArray(res)) {
      return res;
    }
    return [];
  }
}

export async function getMoleculeDetails(id: string) {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const urlParams = `molecule_id=${id}`;
  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}molecule/getMolecule?${urlParams}`;

  return ApiClient.get(Url, _authToken);
}
